export default {
  BulkEditUserBillableRatesModal: () => import('./BulkEditUserBillableRatesModal/BulkEditUserBillableRatesModal.vue'),
};
